import {CompanySettlement, CompanySettlementEntity} from "../../../model/company-settlement";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type CompanySettlementSelectorProps = {
  // selector props
};

export const companySettlementsSelector = () => createSelector(
  [getUseQueryResultData<CompanySettlement[]>],
  (data) => {
    return selectCompanySettlementsAndTransform(
      data ?? [], {}
    );
  }
);

export const companySettlementSelector = () => createSelector(
  [getUseQueryResultData<CompanySettlement>],
  (data) => {
    return data ? transformCompanySettlement(data) : undefined;
  }
);

export const selectCompanySettlements = (values?: CompanySettlement[], selector?: CompanySettlementSelectorProps): CompanySettlement[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;
    return filterIn;
  });
};

export const transformCompanySettlement = (value: CompanySettlement): CompanySettlementEntity => {
  return CompanySettlementEntity.from(value)
}

export const selectCompanySettlementsAndTransform = (values?: CompanySettlement[], selector?: CompanySettlementSelectorProps): CompanySettlementEntity[] => {
  const selected = selectCompanySettlements(values, selector);
  return selected.map(transformCompanySettlement);
};
